import type {
  TopicKnowledgeDataApplySearchCriteriaAction,
  TopicKnowledgeDataClearSearchCriteriaAction,
} from "domains/knowledgeData/actionTypes";
import { TopicKnowledgeDataActionTypes } from "domains/knowledgeData/actionTypes";

export const applyKnowledgeDataSearchCriteria = (
  payload?: TopicKnowledgeDataApplySearchCriteriaAction["payload"],
  meta?: TopicKnowledgeDataApplySearchCriteriaAction["meta"],
): TopicKnowledgeDataApplySearchCriteriaAction => ({
  type: TopicKnowledgeDataActionTypes.APPLY_SEARCH_CRITERIA,
  payload,
  meta,
});

export const clearKnowledgeDataSearchCriteria = (): TopicKnowledgeDataClearSearchCriteriaAction => ({
  type: TopicKnowledgeDataActionTypes.CLEAR_SEARCH_CRITERIA,
});
